module.exports = __webpack_public_path__ + "static/img/logo.c3b46d9f.png";